<question [title]="title" [description]="description"  [valueOnly]="true">
  <div>
    <ion-button expand="full" fill="clear" color="dark" (click)="downloadCert($event)"><div translate>CONTENT.FLOW.DOWNLOAD_CERT</div></ion-button>
  </div>
</question>
